import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ApiService, InvoiceModel } from '@mmx/shared'
import { TranslateService } from '@ngx-translate/core'
import moment from 'moment'
import { filter, switchMap } from 'rxjs'

import { DatePickerDialogComponent } from '../../date-picker-dialog'

@Component({
  selector: 'mmx-invoice-subtitle',
  templateUrl: './invoice-subtitle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InvoiceSubtitleComponent {
  @Input()
  public invoice: InvoiceModel

  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
    private restService: ApiService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef,
  ) { }

  public openDueDateDialog() {
    this.dialog.open(DatePickerDialogComponent, {
      width: '450px',
      panelClass: 'dialog-form',
      data: {
        title: this.translate.instant('invoice-card.due-date-dialog-title'),
        date: this.invoice.dueDate,
        minDate: moment(),
      },
    })
      .afterClosed()
      .pipe(
        filter(Boolean),
        switchMap((date: moment.Moment) => {
          this.invoice.dueDate = date
          return this.restService.updateInvoice(this.invoice)
        }),
      )
      .subscribe({
        next: () => {
          this.openSnackBar(this.translate.instant('invoice-card.due-date-update-success'))
          this.cdr.markForCheck()
        },
        error: () => this.openSnackBar(this.translate.instant('invoice-card.due-date-update-failed')),
      })
  }

  private openSnackBar(message: string) {
    this.snackbar.open(message, null, {
      duration: 5000,
    })
  }
}
